class Callbacks {
  static afterChangeModelHandler(setFormValues, user_city) {
    return function afterChangeModel(value) {
      if (value === 'standard') {
        setFormValues([
          { field: 'vehicle_options', value: undefined },
          { field: 'driver_options', value: undefined },
          { field: 'is_paired', value: true },
          { field: 'drivers', value: undefined },
          { field: 'job', value: undefined },
          { field: 'title', value: undefined },
          { field: 'cities', value: [user_city] },
          { field: 'vehicletypes', value: undefined }
        ])
      }
      else
        setFormValues([
          { field: 'is_paired', value: true }
        ])
    }
  }
}

export default Callbacks
